import { render, staticRenderFns } from "./MessageContentUploading.vue?vue&type=template&id=0f2a12b1&scoped=true"
import script from "./MessageContentUploading.vue?vue&type=script&lang=js"
export * from "./MessageContentUploading.vue?vue&type=script&lang=js"
import style0 from "../../style/message-box.scss?vue&type=style&index=0&id=0f2a12b1&prod&lang=scss&scoped=true&external"
import style1 from "./MessageContentUploading.vue?vue&type=style&index=1&id=0f2a12b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2a12b1",
  null
  
)

export default component.exports